export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
        nuxtApp.vueApp._context.provides.store.commit("common/setNotification", {
			isActive: true,
			text: `Error: ${error.message} in ${JSON.stringify(info)}`
		})

        console.log(error)
    }
})